import { render } from "./EarthquakeCalculator.vue?vue&type=template&id=22b0d7e6"
import script from "./EarthquakeCalculator.vue?vue&type=script&lang=js"
export * from "./EarthquakeCalculator.vue?vue&type=script&lang=js"

import "./EarthquakeCalculator.vue?vue&type=style&index=0&id=22b0d7e6&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__